import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AudioPlayerService } from '../services/audio-player.service';

@Injectable({
  providedIn: 'root'
})
export class AudioPlayerGuard implements CanActivate {
  constructor(private audioPlayerService: AudioPlayerService) {

  }

  canActivate() {
      // console.log('AudioPlayerGuard called');
      return this.audioPlayerService.loadText()
        .pipe(map(responses => {
          // console.warn('audio player is loaded')
           return true;
        }))
      ;

  }

}
